import * as React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
export default function LEssenzaDelGusto() {
  return <section data-section-id="223400" id="larène-des-champions" className="bg-background text-foreground relative h-screen min-h-[600px] w-full overflow-hidden flex items-center justify-center">
      {/* Arrière-plan avec l'URL de votre domaine principal */}
      <div className="absolute inset-0 z-0 bg-fixed bg-cover bg-center" style={{
      backgroundImage: "url('https://asso-kickoffevents.com/wp-content/uploads/2026/07/home_page_background.png')"
    }} />

      {/* Overlay sombre / Gradient */}
      <div className="absolute inset-0 z-10 bg-black/60 bg-gradient-to-b from-black/40 via-primary/10 to-black/80" />

      {/* Contenu principal */}
      <div className="relative z-20 flex h-full w-full flex-col items-center justify-center px-4 text-center">
        <Badge variant="outline" className="mb-8 border-primary/50 bg-black/40 text-primary backdrop-blur-md uppercase tracking-[0.4em] py-2 px-5 font-serif text-xs sm:text-sm">
          LE FOOTBALL DES JEUNES TALENTS
        </Badge>

        <h1 className="font-default text-5xl sm:text-6xl md:text-7xl lg:text-8xl text-white mb-12 max-w-5xl leading-[1.1] font-bold uppercase tracking-tighter drop-shadow-2xl">
          LE TERRAIN OÙ CHAQUE JEUNE ÉCRIT SON HISTOIRE
        </h1>

        <div className="flex flex-col sm:flex-row gap-4">
          <Button asChild size="lg" className="bg-gradient-to-r from-primary to-chart-4 text-primary-foreground hover:opacity-90 rounded-sm px-12 py-8 text-sm sm:text-base tracking-widest uppercase border-none shadow-3xl transition-transform duration-300 hover:scale-105 font-default font-bold">
            <Link to="/TournamentsPage">Calendrier officiel</Link>
          </Button>
        </div>
      </div>

      {/* Indication de défilement */}
      <div className="absolute bottom-8 left-1/2 z-20 -translate-x-1/2 flex flex-col items-center gap-3 opacity-80 hover:opacity-100 transition-opacity">
        <span className="text-primary/80 text-[10px] uppercase tracking-[0.5em] font-serif font-medium">
          Découvrir
        </span>
        <ChevronDown className="text-primary size-6 animate-bounce" strokeWidth={2} />
      </div>
    </section>;
}